import {PKOrientationType} from '../types';

const ScreenOrientationType: PKOrientationType = {
  NONE: 'none',
  ANY: 'any',
  NATURAL: 'natural',
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
  PORTRAIT_PRIMARY: 'portrait-primary',
  PORTRAIT_SECONDARY: 'portrait-secondary',
  LANDSCAPE_PRIMARY: 'landscape-primary',
  LANDSCAPE_SECONDARY: 'landscape-secondary'
};

export {ScreenOrientationType};
